/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Shot_Chat_ThreadInputs */

const en_mk_shot_chat_thread = /** @type {(inputs: Mk_Shot_Chat_ThreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The promo-mingguan channel beside its open thread, showing Sari’s mention of Kira and the agent’s completed reply.`)
};

const id_mk_shot_chat_thread = /** @type {(inputs: Mk_Shot_Chat_ThreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Channel promo-mingguan bersama thread terbuka, menampilkan mention Sari kepada Kira dan balasan agen yang sudah selesai.`)
};

/**
* | output |
* | --- |
* | "The promo-mingguan channel beside its open thread, showing Sari’s mention of Kira and the agent’s completed reply." |
*
* @param {Mk_Shot_Chat_ThreadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_shot_chat_thread = /** @type {((inputs?: Mk_Shot_Chat_ThreadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Shot_Chat_ThreadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_shot_chat_thread(inputs)
	return en_mk_shot_chat_thread(inputs)
});